import { useLocation } from '@ecomm/framework/useLocation'
import { useNinetailedFeatureFlag } from '..'

const usePriceAboveFoldExperience = () =>
  useNinetailedFeatureFlag({ baselineId: '1EZdq1UMf3QRd4dyKSiN2N' })

const useCameraOnlyLPCTAExperience = () => {
  const { isVariant } = useNinetailedFeatureFlag({
    baselineId: 'Lk6Je2UE8TDHICWt3ptLl'
  })
  const location = useLocation()

  return {
    isCameraOnlyVariant: location.pathname === '/cameras-landing' && isVariant
  }
}

export { usePriceAboveFoldExperience, useCameraOnlyLPCTAExperience }
